<template>
  <div>
    <base-fieldset>
      <base-input v-model.trim="keySerial" size="sm" label="serial" clearable />
    </base-fieldset>
    <base-fieldset>
      <base-input
        v-model.trim="keyDeliveryOrder"
        size="sm"
        label="delivery_order_number"
        clearable
      />
    </base-fieldset>
    <base-fieldset>
      <label class="text-xs font-semibold">{{ $t(`mygwf.components.Label.created`) }}</label>
      <date-picker
        class="flex mb-2"
        input-class="bg-secondary-light appearance-none inline-block w-full border rounded-none leading-normal text-sm px-2 py-1 h-8 focus:outline-none focus:bg-white focus:border-primary-light pr-10 flex flex-grow w-auto"
        :editable="false"
        v-model="keyRange"
        :value-type="'YYYY-MM-DD'"
        @clear="keyRange = [null, null]"
        range
        confirm
        :shortcuts="[]"
        :lang="$i18n.locale"
        format="DD. MMM YYYY"
      >
      </date-picker>
    </base-fieldset>
    <base-fieldset>
      <CompanySelect :filterArray="keyCompany" />
    </base-fieldset>
    <base-fieldset>
      <label class="mb-1 block text-xs font-semibold">{{
        $t(`mygwf.components.Label.device_type`)
      }}</label>
      <base-select
        v-model="keyType"
        mode="multiple"
        :options="keyTypes"
        :optionType="{id: 'id', label: 'label'}"
        allowClear
        size="sm"
        class="mb-2"
      />
    </base-fieldset>
  </div>
</template>

<script>
import {BaseFieldset, BaseInput, BaseSelect, BaseIcon, BaseButtonIcon} from '@/components/base'
import CompanySelect from '@/components/shared/CompanySelect.vue'
import _isEmpty from 'lodash-es/isEmpty'

export default {
  mounted() {
    this.populateFilters();
  },
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    dateValue(date) {
      const d = new Date(date)
      return d.toISOString()
    },
    submit() {
      let filters = {
        value: [this.keySerial, this.keyDeliveryOrder, this.keyType, this.keyCompany],
        name: ['serial', 'delivery_order_number', 'type', 'company'],
      }

      const created_after =
        this.keyRange && this.keyRange[0] ? this.dateValue(this.keyRange[0]) : null
      const created_before =
        this.keyRange && this.keyRange[1] ? this.dateValue(this.keyRange[1]) : null
      filters.value = filters.value.concat([created_after, created_before])
      filters.name = filters.name.concat(['created_after', 'created_before'])
      this.$store.dispatch('app/filterProp', filters)
    },
    reset() {
      this.keySerial = ''
      this.keyDeliveryOrder = ''
      this.keyType = []
      this.keyCompany = []
      this.keyRange = ['', '']
      this.$router.push({ name: 'Keys', query: {} });
    },
    populateFilters() {
      let query = this.$route.query;

      const extractValuesFromQuery = (data, type) => {
        let result = []
        if (!data) {
          return result
        }
        if (Array.isArray(data)) {
          if (type === 'number') {
            result = [...data.map(e => +e)]
          } else {
            result = [...data]
          }
        } else {
          if (type === 'number') { data = +data; }
          result.push(data)
        }
        return result
      }

      this.keyType = extractValuesFromQuery(query.type, 'number')
      this.keyCompany = extractValuesFromQuery(query.company, 'number')
    },
  },
  data() {
    return {
      keySerial: this.$route.query.serial || '',
      keyDeliveryOrder: this.$route.query.delivery_order_number || '',
      keyType: [],
      keyCompany: [],
      keyRange: [this.$route.query.created_after, this.$route.query.created_before],
      visible: false,
      securityCheck: '',
    }
  },
  watch: {
    $route(n, o) {
      if (_isEmpty(n.query)) {
        this.reset()
      }
    },
    keySerial(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'serial'})
    },
    keyDeliveryOrder(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'delivery_order_number'})
    },
    keyCompany(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'company'})
    },
    keyType(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'type'})
    },
    keyRange(n, o) {
      if (this.mobile) {
        return
      }
      if (n) {
        const created_after = n[0] ? this.dateValue(n[0]) : null
        const created_before = n[1] ? this.dateValue(n[1]) : null

        this.$store.dispatch('app/filterProp', {
          value: [created_after, created_before],
          name: ['created_after', 'created_before'],
        })
      }
    },
  },
  computed: {
    keyTypes() {
      return this.$store.getters['devices/moduleTypes'].map(t => {
        return {id: Number.parseInt(t.value, 10), label: t.label}
      })
    },
  },
  components: {
    BaseFieldset,
    BaseInput,
    BaseSelect,
    BaseIcon,
    CompanySelect,
    BaseButtonIcon,
  },
}
</script>

<style scoped>
.mx-datepicker-range {
  width: auto !important;
}
</style>
